import { toast as sonnerToast } from 'sonner'
import { useI18n } from '@/lib/hooks/use-i18n'

type ToastProps = {
  title?: string
  description?: string
  variant?: 'default' | 'destructive'
}

export function useToast() {
  const { t } = useI18n()

  return {
    toast: ({ title, description, variant = 'default' }: ToastProps) => {
      if (variant === 'destructive') {
        sonnerToast.error(title || t('common.toast.error'), {
          description,
        })
      } else {
        sonnerToast.success(title || t('common.toast.success'), {
          description,
        })
      }
    }
  }
}
